const renderAgeCheck = (crossrefChecks) => {
    const formatAgeCheck = (ageCheckItem, index) => {
        let ageCheckFormattedResult;

        if (ageCheckItem.reason === 'too_old') {
            ageCheckFormattedResult = 'Too old'
        } else {
            ageCheckFormattedResult = 'Too recent'
        }

        const now = new Date();
        const publishedDate = new Date(ageCheckItem.originalData.publishedDate);

        const yearDiffsMs = now.getTime() - publishedDate.getTime();
        const yearDiffs = Math.floor(yearDiffsMs / 1000 / 60 / 60 / 24 / 365);

        ageCheckFormattedResult += `, ${yearDiffs} years old`;

        return <p className="mb-1">{index + 1}. {ageCheckItem.doi} {ageCheckFormattedResult}</p>
    };

    return (
        <div className="mb-2">
            <div className="mb-1"><b>Age check: </b></div>
            {crossrefChecks.ageCheck.map((ac, index) => formatAgeCheck(ac, index))}
            <hr className={'hr'}/>
        </div>
    )
};

const renderCitationCartel = (crossrefChecks) => {
    const formatCitationCartel = (citationCartelItem, index) => {
        let suspiciousDois = ''
        for (let suspicuosDoi of citationCartelItem.originalData.suspiciousDois) {
            suspiciousDois += '\n' + suspicuosDoi.doi + ': ' + suspicuosDoi.count;
        }

        const citationCartelFormattedResult = `Citations appears: ${suspiciousDois}`;

        return <p className="mb-1">{index + 1}. {citationCartelItem.doi} {citationCartelFormattedResult}</p>
    };

    return (
        <div className="mb-2">
            <div className="mb-1"><b>Citation cartel: </b></div>
            {crossrefChecks.citationCartel.map((cc, index) => formatCitationCartel(cc, index))}
            <hr className={'hr'}/>
        </div>
    )
};

const renderSelfCitation = (crossrefChecks) => {
    return (
        <div className="mb-2">
            <b>Self citation: </b><span>self citation</span>
            <hr className={'hr'}/>
        </div>
    )
};
const renderTitleComparison = (crossrefChecks) => {
    const formatTitleComparison = (titleComparisonItem, index) => {
        const titleComparisonFormattedResult = (
            <>
                <span>
                    Title <i>"{titleComparisonItem.originalTitle}"</i> does not match the title from Crossref: <i>"{titleComparisonItem.title}"</i>
                </span>
            </>
        );

        return <p className="mb-1">{index + 1}. {titleComparisonItem.doi} {titleComparisonFormattedResult}</p>
    };

    return (
        <div className="mb-2">
            <div className="mb-1"><b>Title match: </b></div>
            {crossrefChecks.titleMatch.map((tm, index) => formatTitleComparison(tm, index))}
            <hr className={'hr'}/>
        </div>
    )
};
const renderJournalComparison = (crossrefChecks) => {
    const formatJournalComparison = (journalComparisonItem, index) => {
        const journalComparisonFormattedResult = (
            <>
                <span>
                    Journal <i>"{journalComparisonItem.originalJournal}"</i> does not match the journal from Crossref: <i>"{journalComparisonItem.journal}"</i>
                </span>
            </>
        );

        return <p className="mb-1">{index + 1}. {journalComparisonItem.doi} {journalComparisonFormattedResult}</p>
    };

    return (
        <div className="mb-2">
            <div className="mb-1"><b>Journal match: </b></div>
            {crossrefChecks.journalMatch.map((jm, index) => formatJournalComparison(jm, index))}
        </div>
    )
};

export const renderCrossrefChecksItem = (crossrefChecks) => {
    return <div>
        {crossrefChecks.ageCheck? renderAgeCheck(crossrefChecks) : <></>}
        {crossrefChecks.citationCartel ? renderCitationCartel(crossrefChecks) : <></>}
        {crossrefChecks.selfCitation ? renderSelfCitation(crossrefChecks) : <></>}
        {crossrefChecks.titleMatch ? renderTitleComparison(crossrefChecks) : <></>}
        {crossrefChecks.journalMatch ? renderJournalComparison(crossrefChecks) : <></>}
    </div>
};
